export default __webpack_public_path__ + "static/media/terasse-2.f4bc71a0.jpeg";